import imageCarousel from './image-carousel';
export default imageCarousel;
